import { Container, HeaderLogo, HeaderSubMenu } from "./styles";

import logo from "../../assets/logoInfoSaude2.png";
import logo2 from "../../assets/logoCieges.svg";

import { FlexBox } from "../../styles/global";
import "./styles.scss";
import { Link, useLocation } from "react-router-dom";
import { useDataContext } from "../../context/DataContext";
import TimeDisplay from "../../utils/timeConvert";

// import LoginModalButton from "components/Login/LoginModalButton";

const Header = () => {
  const { isSmallScreen, metricasEspecialidades } = useDataContext();
  const location = useLocation();

  return (
    <Container>
      {isSmallScreen ? (
        <>
          <FlexBox width="100%" align="center" justify="center">
            <h1>Portas do Serviço Hospitalar de Emergência (SHE)</h1>
          </FlexBox>
          <FlexBox justify="space-around">
            <img src={logo} style={{ width: "30%" }} />
            <img src={logo2} style={{ width: "30%" }} />
          </FlexBox>
          <FlexBox justify="space-around" style={{ color: "white" }}>
            <p style={{ width: "50%", textAlign: "center" }}>Fonte: TrakCare</p>
            <p style={{ width: "50%", textAlign: "center" }}>
              Última Atualização:
              <span>
                {Object.keys(metricasEspecialidades).length > 0 &&
                  TimeDisplay(metricasEspecialidades)}
              </span>
              <br />
              (atualização a cada 5 minutos)
            </p>
          </FlexBox>
        </>
      ) : (
        <>
          <HeaderLogo>
            <img src={logo} alt="imagem" />
          </HeaderLogo>
          <FlexBox
            width="100%"
            align="center"
            justify="center"
            direction="column"
            gap="9px"
          >
            <h1>Portas do Serviço Hospitalar de Emergência (SHE)</h1>
            <HeaderSubMenu width="auto" gap="63px">
              {location.pathname === "/card" ? (
                <Link to="/">
                  <h2>Mapa</h2>
                </Link>
              ) : (
                <Link to="/card">
                  <h2>Detalhado</h2>
                </Link>
              )}
              {/* <LoginModalButton></LoginModalButton> */}
            </HeaderSubMenu>
          </FlexBox>
          <HeaderLogo>
            <img src={logo2} alt="imagem" />
            {/* <FlexBox justify="space-between" direction="column" gap="2px"> */}
            <FlexBox justify="space-between">
              <p>
                Fonte:
                <span>TrakCare</span>
              </p>
              <FlexBox direction="column" width="fit-content">
                <p>
                  Última Atualização:
                  <span>
                    {Object.keys(metricasEspecialidades).length > 0 &&
                      TimeDisplay(metricasEspecialidades)}
                  </span>
                </p>
                <p style={{ textAlign: "center", fontSize: "0.8rem" }}>
                  (atualização a cada 5 minutos)
                </p>
              </FlexBox>
            </FlexBox>
            {/* </FlexBox> */}
          </HeaderLogo>
        </>
      )}
    </Container>
  );
};

export default Header;
